import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    accessoriesData: [],
    metadataAccessories: {
        limit: 0,
        offset: 0,
        total: 0,
    },
}

const AccessoriesReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_ACCESSORIES:
            return {
                ...state,
                accessoriesData: action.payload.data,
                metadataAccessories: { ...action.payload.metadata },
            }

        default:
            return { ...state }
    }
}

export default AccessoriesReducer
